// "¿Hay trabajo del cliente esperando en esta ficha?"
//
// Al cerrar el editor le decimos «tu diseño se ha guardado, puedes
// volver cuando quieras» (customizer/close-feedback.ts). Al volver, la
// ficha de producto le enseñaba el mismo «Personalizar ahora» de la
// primera visita: ni una señal de que su trabajo siga ahí. La promesa
// se cumplía —el borrador se restaura al abrir— pero el cliente no
// tenía forma de saberlo sin volver a entrar, que es justo el gesto
// que no da quien cree que ha perdido lo que hizo.
//
// Este módulo NO IMPORTA NADA a propósito. Vive en el entry
// `embed.js`, que tiene presupuesto de bytes: leer el borrador con
// `loadDraft` habría arrastrado el saneador de render-core —decenas de
// kB— a la carga inicial de todas las fichas de la tienda. Aquí sólo
// se mira una bandera, sin tocar el contenido del borrador.

/** Clave de almacenamiento del borrador. Fuente única: la usan tanto
 *  este lector como el autoguardado. */
export function draftStorageKey(shop: string, templateId: string): string {
  return `dfp:draft:${shop}:${templateId}`;
}

/** Un borrador de hace medio año no es "tu diseño", es un recuerdo.
 *  Pasado este plazo el botón vuelve a su texto de siempre. */
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

/**
 * ¿El borrador guardado lo escribió el CLIENTE, y es reciente?
 *
 * La bandera `edited` la estampa el autoguardado sólo cuando la
 * escritura llega después del primer gesto real. Sin ella bastaría con
 * abrir y cerrar: el personalizador siembra los valores por defecto al
 * arrancar y eso ya crea un borrador, así que el botón habría dicho
 * "continúa tu diseño" a quien no diseñó nada.
 */
export function hasEditedDraft(shop: string, templateId: string): boolean {
  try {
    const raw = localStorage.getItem(draftStorageKey(shop, templateId));
    if (!raw) return false;
    const j = JSON.parse(raw) as { edited?: boolean; ts?: number };
    if (j?.edited !== true) return false;
    const ts = typeof j.ts === 'number' ? j.ts : 0;
    return ts > 0 && Date.now() - ts < MAX_AGE_MS;
  } catch {
    // Modo privado, cuota, JSON corrupto: sin bandera, botón de siempre.
    return false;
  }
}
